module.exports = __webpack_public_path__ + "static/sc-01.eb4d0d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/sornting/sc-01.png
// module id = 92
// module chunks = 4358026223460 88197199937824 213720915766396